/* eslint-disable no-unused-vars */
import debugFactory from "debug";
import { SocketMessageType } from "@teaming/common-enums";
import { clientIdentifier } from "@teaming/io-helpers";
import { debounce } from "@teaming/common-util";

export function configureSockets( { storeName, goalsStoreName, store, navigation, ioSocket, ioGokr, alerts, } ) {
	const debug = debugFactory( `teaming:common-gokr:stores:${ storeName }:sockets` );
	const getter = getterName => store.getters[ `${ storeName }/${ getterName }` ];
	const commit = ( mutationName, args ) => store.commit( `${ storeName }/${ mutationName }`, args );

	const { success, error, info, } = alerts;
	// eslint-disable-next-line no-magic-numbers
	const notifyExternalChange = debounce( () => info( "externalChangeNotification" ), 200 );

	[
		SocketMessageType.GOAL_CREATED,
		SocketMessageType.GOAL_UPDATED,
	].forEach( socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			debug( "received socket message", message );
			const { body, clientIdentifier: messageClientIdentifier, } = message;
			const { goalId, } = body;
			const isMessageFromMe = ( messageClientIdentifier === clientIdentifier );
			const isStoreGoal = goalId === getter( "context" ).goalId;
			if ( isStoreGoal ) {
				const { data: activity, } = await ioGokr.fetchGoalActivity( { goalId, }, { refetch: true, } );
				commit( "receiveGoalActivity", activity );
			}
			const inGoalRoute = navigation.store.inGoalRoute( { goalId, } );
			if ( isStoreGoal && inGoalRoute && !isMessageFromMe ) {
				notifyExternalChange();
			}
		} );
	} );

	[
		SocketMessageType.KEYRESULT_CREATED,
		SocketMessageType.KEYRESULT_UPDATED,
		SocketMessageType.KEYRESULT_DELETED,
	].forEach( socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			debug( "received socket message", message );
			const { body, } = message;
			const { goalId, } = body;
			const isStoreGoal = goalId === getter( "context" ).goalId;
			if ( isStoreGoal ) {
				const promises = [
					ioGokr.fetchGoalActivity( { goalId, }, { refetch: true, } ),
					ioGokr.fetchGoal( { goalId, }, { refetch: true, } ),
				];
				const [ activity, goal, ] = ( await Promise.all( promises ) ).map( response => response.data );
				commit( "receiveGoalActivity", activity );
				commit( "receiveKeyResults", goal );
			}
		} );
	} );

	[
		SocketMessageType.GOAL_COMMENT,
		SocketMessageType.KEYRESULT_COMMENT,
	].forEach( socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			debug( "received socket message", message );
			const { body, clientIdentifier: messageClientIdentifier, } = message;
			const { goalId, } = body;
			const isMessageFromMe = ( messageClientIdentifier === clientIdentifier );
			const isStoreGoal = goalId === getter( "context" ).goalId;
			if ( isStoreGoal ) {
				const { data: activity, } = await ioGokr.fetchGoalActivity( { goalId, }, { refetch: true, } );
				commit( "receiveGoalActivity", activity );
			}
		} );
	} );
}

export function configureChannels( { storeName, goalsStoreName, store, navigation, ioChannel, alerts, } ) {
	const debug = debugFactory( `teaming:common-gokr:stores:${ storeName }:channels` );
}
